import * as types from "../actions/types";
import { toast } from "react-toastify";

const initialState = {
    list: [],
    listLoading: false,
    listPatientId: -1,
    listLoaded: 0,

    created: false,
    createError: false,
    createLoading: false,

    editLoading: false,
    editError: false,

    deleteLoading: false,
    deleteError: false
};

function reports(state = initialState, action) {
    switch (action.type) {
        // FETCH
        case types.REPORTS_FETCH_REQUESTED: {
            return Object.assign({}, state, {
                listLoading: true,
                listLoaded: 0,
                listPatientId: -1,
            });
        }
        case types.REPORTS_FETCH_SUCCESS: {
            return Object.assign({}, state, {
                listLoading: false,
                list: action.data,
                listPatientId: action.patientId,
                listLoaded: Date.now()
            });
        }
        case types.REPORTS_FETCH_FAILURE: {
            return Object.assign({}, state, { listLoading: false, list: [] });
        }
        // CREATE
        case types.REPORTS_CREATE_REQUESTED: {
            return Object.assign({}, state, {
                createLoading: true,
                created: false
            });
        }
        case types.REPORTS_CREATE_SUCCESS: {
            toast.success("Le compte-rendu d'entretien a bien été créé", { autoClose: 5000 });
            return Object.assign({}, state, {
                createLoading: false,
                createError: false,
                created: action.data,
                list: [action.data, ...state.list],
            });
        }
        case types.REPORTS_CREATE_FAILURE: {
            toast.error("Le compte-rendu d'entretien n'a pas pu être créé");
            return Object.assign({}, state, {
                createLoading: false,
                createError: action.data,
                created: false
            });
        }
        // EDIT
        case types.EDIT_REPORT_REQUESTED: {
            return Object.assign({}, state, {
                editLoading: true,
                editError: false
            });
        }
        case types.EDIT_REPORT_SUCCESS: {
            return Object.assign({}, state, {
                listPatientId: action.patientId,
                listLoaded: Date.now()
            });
        }
        case types.EDIT_REPORT_FAILURE: {
            return Object.assign({}, state, {
                editLoading: false,
                editError: action.data
            });
        }
        // REMOVE
        case types.REPORT_REMOVE_REQUESTED: {
            return Object.assign({}, state, {
                deleteLoading: true,
                deleteError: false
            });
        }
        case types.REPORT_REMOVE_SUCCESS: {
            toast.success("Le compte-rendu d'entretien a été supprimé");
            return Object.assign({}, state, {
                deleteLoading: false,
                list: state.list.filter(report => report.id !== action.data.id)
            });
        }
        case types.REPORT_REMOVE_FAILURE: {
            toast.error("Le compte-rendu d'entretien n'a pas pu être supprimé");
            return Object.assign({}, state, {
                deleteLoading: false,
                deleteError: action.data
            });
        }
        // DEFAULT
        default:
            return state;
    }
}

export default reports;
